import React, { useEffect } from 'react';

import { init } from './helpers/animation.js';

import Morph from './components/Morph';
import Feature from './components/Feature';

import {
  Scaffold,
  Footer
} from './styles';

const Features = () => {
  useEffect(() => {
    init();
  }, []);

  return (
    <Scaffold>
      <Morph />
      <Feature name="EASY" />
      <Feature name="ENGAGING" color="#7726FD" isInverted />
      <Feature name="SAVE_MONEY" color="#FFA500" isGetStarted />
      <Feature name="TRANSPARENT" color="#13B84E" isInverted />
      <Feature name="COMPLETE" color="#FF2725" isGetStarted />
      <Footer className="content content--related" />
    </Scaffold>
  );
};

export default Features;
